export default __webpack_public_path__ + "static/one_office-46008cb1ef05d768e09d9722df46184a.png";